import { Routes } from '@angular/router';
import { ListingComponent } from './components/listing.component';
import { ListingsComponent } from './components/listings.component';
import { OurHomesComponent } from './components/our-homes.component';

export const routes: Routes = [{
  path: '', component: OurHomesComponent, children: [
    { path: '', component: ListingsComponent },
    { path: ':state/:county/:city/:address/:zipCode/listing/:timeline_id', component: ListingComponent },
    { path: '**', redirectTo: '' },
  ]
}]